<template>
  <v-container fluid style="height: 100%" class="mt-4">
    <v-toolbar>
      <v-btn color="red" outlined :to="'/settings/mailtemplates'"
        >Abbrechen</v-btn
      >
      <v-spacer />
      <v-text-field
        outlined
        dense
        hide-details
        label="Name"
        v-model="template.name"
      />

      <v-spacer />

      <v-btn outlined color="green" @click="saveTemplate">Speichern</v-btn>
      <v-btn class="ml-2 white--text" color="green" @click="saveTemplateClose"
        >Speichern & Schließen</v-btn
      >
    </v-toolbar>

    <EmailEditor
      v-if="templateLoaded"
      locale="de"
      ref="emailEditor"
      @load="editorLoaded"
    />
  </v-container>
</template>

<script>
import MailTemplateService from "@/services/MailTemplateService";
import { EmailEditor } from "vue-email-editor";

export default {
  components: { EmailEditor },
  data: () => ({
    templateLoaded: false,
    closeForm: false,
    template: {
      _id: null,
      name: "",
      html: "",
      json: ""
    }
  }),
  methods: {
    editorLoaded() {
      console.log("loaded");
      this.$refs.emailEditor.editor.loadDesign(this.template.json);
    },

    designLoaded() {
      this.$store.commit("SET_APP_LOADING", false);
    },

    saveTemplateClose() {
      this.closeForm = true;
      this.saveTemplate();
    },

    saveTemplate() {
      const vm = this;
      this.$refs.emailEditor.editor.exportHtml(data => {
        vm.template.html = data.html;
        vm.template.json = JSON.stringify(data.design) || "";

        MailTemplateService.save({ _id: vm.template._id, data: vm.template })
          .then(result => {
            if (result.data.success == true) {
              this.$notify({
                group: "dataline",
                type: "success",
                title: "Speichern erfolgreich",
                text: "Dein Template wurde erfolgreich gespeichert"
              });
              if (this.closeForm) {
                this.$router.push({ name: "mailtemplates" });
              }
            } else {
              this.$notify({
                group: "dataline",
                type: "error",
                title: "Fehler beim speichern",
                text: result.message
              });
            }
          })
          .catch(error => {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler beim speichern",
              text: error.message
            });
          });
      });
    }
  },
  created() {
    const id = this.$route.params.id;

    if (id) {
      MailTemplateService.get(id)
        .then(result => {
          if (result.data) {
            this.template = result.data.data[0];
            this.template.json = JSON.parse(this.template.json);
            this.templateLoaded = true;
          }
        })
        .catch(error => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message
          });
        })
        .finally(() => {});
    } else {
      this.templateLoaded = true;
    }
  },
  mounted() {}
};
</script>
<style scoped>
.unlayer-editor {
  height: 90%;
  min-height: 90%;
}
</style>
